import { useMemo, useRef, useState } from "react"
import { REACT_QUILL_FORMATS, REACT_QUILL_MODULE_TOOLBAR } from "../constants"
import ReactQuill from "react-quill"
import { Box, CircularProgress, Typography } from "@mui/material";
import { uploadImage } from '../services/upload';
import { enqueueSnackbar } from "notistack";
import { API_BASE_URL } from "../services/config";

const Editor = ({
  value,
  onChange
}) => {

  const [is_uploading_image, set_is_uploading_image] = useState(false);
  const quillRef = useRef();
  
  const handleImageUpload = () => {

    const editor = quillRef.current.getEditor();

    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");
    input.click();
    input.onchange = async () => {
      if (input !== null && input.files !== null) {
        set_is_uploading_image(true)
        const file = input.files[0];

        const formData = new FormData();
        formData.append('document', file);

        const {data} = await uploadImage({
          data : formData
        });

        if(data){
          const filename = data.filename;
          const image_url = `${API_BASE_URL}/uploads/${filename}`;
          editor.insertEmbed(editor.getSelection().index, "image", image_url);
          set_is_uploading_image(false);
        }else{
          enqueueSnackbar('Error while uploading image', {
            variant : 'error'
          })
        }
      }
    };
  }

  const REACT_QUILL_MODULES = useMemo(() => {
    return {
      toolbar: {
        container: REACT_QUILL_MODULE_TOOLBAR,
        handlers: {
          image: handleImageUpload
        }
      }
    }
  // eslint-disable-next-line
  }, [])

  return (

    <Box
      position='relative'
    >
      <ReactQuill
        ref={quillRef}
        theme="snow"
        value={value}
        onChange={onChange}
        modules={REACT_QUILL_MODULES}
        formats={REACT_QUILL_FORMATS}
      />

      {
        is_uploading_image &&
        <Box
          position='absolute'
          height='100%'
          width='100%'
          top={0}
          left={0}
          bgcolor='rgba(255,255,255,0.9)'
          display='flex'
          flexDirection='column'
          alignItems='center'
          justifyContent='center'
          gap='20px'
        >
          <CircularProgress
            size='50px'
          />
          <Typography>
            Uploading Image . . .
          </Typography>
        </Box>
      }
    </Box>
  )
}

export default Editor;